/**
 * FE-C2f: Admin & users console — contract paths for admin.route.js.
 */

import { buildContractPath } from "./api/contract-client.js";

export const ADMIN_CONSOLE_TIMEOUT_MS = 16000;
export const ADMIN_CONSOLE_WRITE_TIMEOUT_MS = 12000;
export const ADMIN_BACKUP_FETCH_TIMEOUT_MS = 300000;

export function buildAuthAdminsPath() {
  return buildContractPath("get__auth_admins");
}

export function buildAuthUsersPath() {
  return buildContractPath("get__auth_users");
}

/** @param {string} username */
export function buildPostAuthUsersPath() {
  return buildContractPath("post__auth_users");
}

/** @param {string} username */
export function buildAuthUsersPolicyPath(username) {
  return buildContractPath("get__auth_users_p_policy", { pathParams: [username] });
}

/** @param {string} username */
export function buildPutAuthUsersPolicyPath(username) {
  return buildContractPath("put__auth_users_p_policy", { pathParams: [username] });
}

/** @param {string} username */
export function buildDeleteAuthUserPath(username) {
  return buildContractPath("delete__auth_users_p", { pathParams: [username] });
}

/** @param {string} username */
export function buildPostAuthAdminClosePath(username) {
  return buildContractPath("post__auth_admins_p_close", { pathParams: [username] });
}

/** @param {string} deviceId */
export function buildAdminDeviceSharesPath(deviceId) {
  return buildContractPath("get__admin_devices_p_shares", { pathParams: [deviceId] });
}

/** @param {string} deviceId */
export function buildAdminDeviceSharePath(deviceId) {
  return buildContractPath("post__admin_devices_p_share", { pathParams: [deviceId] });
}

/** @param {string} deviceId @param {string} granteeUsername */
export function buildAdminDeviceShareRevokePath(deviceId, granteeUsername) {
  return buildContractPath("delete__admin_devices_p_share_p", {
    pathParams: [deviceId, granteeUsername],
  });
}

export function buildAdminSmtpStatusPath() {
  return buildContractPath("get__admin_smtp_status");
}

export function buildPostAdminSmtpTestPath() {
  return buildContractPath("post__admin_smtp_test");
}

export function buildAdminAlertRecipientsPath() {
  return buildContractPath("get__admin_alert-recipients");
}

export function buildPostAdminAlertRecipientsRequestVerifyPath() {
  return buildContractPath("post__admin_alert-recipients_request-verify");
}

export function buildPostAdminAlertRecipientsPath() {
  return buildContractPath("post__admin_alert-recipients");
}

/** @param {string} recipientId */
export function buildDeleteAdminAlertRecipientPath(recipientId) {
  return buildContractPath("delete__admin_alert-recipients_p", { pathParams: [recipientId] });
}

/** @param {string} recipientId */
export function buildPatchAdminAlertRecipientPath(recipientId) {
  return buildContractPath("patch__admin_alert-recipients_p", { pathParams: [recipientId] });
}

/** @param {string} granteeUsername */
export function buildAdminGranteeAlertRecipientsPath(granteeUsername) {
  return buildContractPath("get__admin_grantee-alert-recipients", {
    query: { grantee_username: granteeUsername },
  });
}

export function buildPostAdminGranteeAlertRecipientsRequestVerifyPath() {
  return buildContractPath("post__admin_grantee-alert-recipients_request-verify");
}

export function buildPostAdminGranteeAlertRecipientsPath() {
  return buildContractPath("post__admin_grantee-alert-recipients");
}

/** @param {string} granteeUsername @param {string} recipientId */
export function buildDeleteAdminGranteeAlertRecipientPath(granteeUsername, recipientId) {
  return buildContractPath("delete__admin_grantee_p_alert-recipients_p", {
    pathParams: [granteeUsername, recipientId],
  });
}

export function buildAdminTelegramStatusPath() {
  return buildContractPath("get__admin_telegram_status");
}

export function buildAdminTelegramBindingsPath() {
  return buildContractPath("get__admin_telegram_bindings");
}

export function buildPostAdminTelegramTestPath() {
  return buildContractPath("post__admin_telegram_test");
}

export function buildPostAdminTelegramBindSelfPath() {
  return buildContractPath("post__admin_telegram_bind-self");
}

/** @param {string} chatId */
export function buildDeleteAdminTelegramBindingPath(chatId) {
  return buildContractPath("delete__admin_telegram_bindings_p", { pathParams: [chatId] });
}

/** @param {string} chatId @param {boolean} enabled */
export function buildPatchAdminTelegramBindingEnabledPath(chatId, enabled) {
  return buildContractPath("patch__admin_telegram_bindings_p_enabled", {
    pathParams: [chatId],
    query: { enabled: enabled ? "true" : "false" },
  });
}

export function buildPostTelegramLinkTokenPath() {
  return buildContractPath("post__telegram_link-token");
}

export function buildAdminBackupExportPath() {
  return buildContractPath("get__admin_backup_export");
}

export function buildAdminBackupImportPath() {
  return buildContractPath("post__admin_backup_import");
}

export function buildAuthSignupPendingPath() {
  return buildContractPath("get__auth_signup_pending");
}

/** @param {string} username */
export function buildPostAuthSignupApprovePath(username) {
  return buildContractPath("post__auth_signup_approve_p", { pathParams: [username] });
}

/** @param {string} username */
export function buildPostAuthSignupRejectPath(username) {
  return buildContractPath("post__auth_signup_reject_p", { pathParams: [username] });
}
